import React, { useEffect } from 'react'
import Bounce from 'react-reveal/Bounce'
import { FormContext, useForm } from 'react-hook-form'
import { Grid, Card, CardContent, FontIcon } from 'react-md'

import { handleSubmit, Input } from 'components/form'
import { Cell, ButtonCustom } from 'components/core'
import { history } from 'utils/history'

import Logo from 'components/core/logo'

import { defaultValues, validationSchema } from './config'
import { handleSend } from './actions'

const Component: React.FC = () => {
  const form = useForm({ defaultValues })

  useEffect(() => {
    document.title = 'Esqueci Minha Senha'
  }, [])

  return (
    <Bounce bottom>
      <Grid>
        <Cell tabletSize={6} tabletStart={2} desktopSize={4} desktopStart={5}>
          <Card fullWidth>
            <CardContent>
              <FormContext {...form}>
                <Logo />
                <Input name='email' label='Email *' rightChildren={<FontIcon>person</FontIcon>} />
                <Input name='login' label='Usuário *' rightChildren={<FontIcon>account_box</FontIcon>} />
                <ButtonCustom
                  text='Enviar Código'
                  icon={<FontIcon>send</FontIcon>}
                  disabled={!form.formState.dirty}
                  whiteThemeBackgroundColor={'#0277bd'}
                  darkThemeBackgroundColor={'#01579b'}
                  onClick={async () => await handleSubmit(form, validationSchema, async () => await handleSend(form.getValues()))}
                  style={{ width: '100%' }}
                />
                <ButtonCustom
                  text='Voltar'
                  icon={<FontIcon>arrow_back</FontIcon>}
                  whiteThemeBackgroundColor={'#e0e0e0'}
                  darkThemeBackgroundColor={'#424242'}
                  onClick={async () => history.push('/')}
                  style={{ width: '100%' }}
                />
                <ButtonCustom
                  text='Já Tenho um Código'
                  icon={<FontIcon>qr_code</FontIcon>}
                  whiteThemeBackgroundColor={'#4db6ac'}
                  darkThemeBackgroundColor={'#00695c'}
                  onClick={async () => history.push('/forgot-password/update-password')}
                  style={{ width: '100%' }}
                />
              </FormContext>
            </CardContent>
          </Card>
        </Cell>
      </Grid>
    </Bounce>
  )
}

export default Component
